import { useAuth } from '@/features/auth';
import { CommentComposer } from './CommentComposer';
import { CommentGate } from './CommentGate';
import { CommentList } from './CommentList';

export function CommentSection({ articleId }: { articleId: string }) {
  const { user } = useAuth();
  return (
    <section aria-label="Comments">
      <h2 className="mb-5 font-display text-2xl font-bold text-foreground">Discussion</h2>
      <div className="mb-8">{user ? <CommentComposer articleId={articleId} /> : <CommentGate />}</div>
      <CommentList articleId={articleId} />
    </section>
  );
}
